var chunkMapping = {
	"0": [
		4649
	],
	"74": [
		5056
	],
	"150": [
		5132
	],
	"151": [
		5133
	],
	"154": [
		5136
	],
	"155": [
		5137
	],
	"156": [
		5138
	],
	"157": [
		5139
	],
	"158": [
		5140
	],
	"159": [
		5141
	],
	"160": [
		5142
	],
	"161": [
		5143
	],
	"162": [
		5144
	],
	"163": [
		5145
	],
	"164": [
		5146
	],
	"165": [
		5147
	],
	"166": [
		5148
	],
	"167": [
		5149
	],
	"168": [
		5150
	],
	"169": [
		5151
	],
	"170": [
		5152
	]
};
var idToExternalAndNameMapping = {
	"4649": [
		"default",
		"./Containers",
		3796
	],
	"5056": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5132": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5133": [
		"default",
		"./HostWrapper",
		3796
	],
	"5136": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5137": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5138": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5139": [
		"default",
		"./AuditDialog",
		3796
	],
	"5140": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5141": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5142": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5143": [
		"default",
		"./PaymentModal",
		3796
	],
	"5144": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5145": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5146": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5147": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5148": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5149": [
		"default",
		"./Challenge",
		3796
	],
	"5150": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5151": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5152": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4649": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5056": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5132": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5133": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5137": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5138": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5139": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5140": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5141": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5142": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5143": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5144": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5145": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5146": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5147": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5148": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5149": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5150": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5151": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5152": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}